import React, {Component} from 'react';
import {connect} from "react-redux";
import {countDeliveryPrice} from "../../actionCreators";
import iconInstallation from "../../img/general/icon-included.png";

class DeliveryData extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderDeliveryCost = () => {
    const {deliveryData} = this.props;
    return (
      <ul className="delivery-info__cost-list">
        {/*{deliveryData.additional_distance_price ? (*/}
        {/*  <li className="delivery-info__cost-item">*/}
        {/*    <div className="delivery-info__cost-item-left">Additional distance price</div>*/}
        {/*    <div className="delivery-info__cost-item-right">{deliveryData.additional_distance_price} &#8364;</div>*/}
        {/*  </li>*/}
        {/*) : ( '' )}*/}
        {deliveryData.bring_through_window_price ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Möbellift</div>
            <div className="delivery-info__cost-item-right">{deliveryData.bring_through_window_price} &#8364;</div>
          </li>
        ) : ( '' )}
        {deliveryData.delivery_items_in_trucks ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Liefergebühr</div>
            <div className="delivery-info__cost-item-right">{deliveryData.delivery_items_in_trucks} &#8364;</div>
          </li>
        ) : ( '' )}
        {deliveryData.express_price ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Express Zuschlag</div>
            <div className="delivery-info__cost-item-right">{deliveryData.express_price} &#8364;</div>
          </li>
        ) : ( '' )}
        {deliveryData.lifting_price ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Lieferung bis in die Wohnung</div>
            <div className="delivery-info__cost-item-right">{deliveryData.lifting_price} &#8364;</div>
          </li>
        ) : ( '' )}
        {deliveryData.installation_price ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Montage</div>
            <div className="delivery-info__cost-item-right">{deliveryData.installation_price} &#8364;</div>
          </li>
        ) : ( '' )}
        {deliveryData.trucks_required ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Anzahl der Lieferfahrzeuge</div>
            <div className="delivery-info__cost-item-right">{deliveryData.trucks_required}</div>
          </li>
        ) : ( '' )}
        <div className="line-price"></div>
        {deliveryData.total_price ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Gesamtpreis (brutto)</div>
            <div className="delivery-info__cost-item-right delivery-info__cost-item-right--red">{deliveryData.total_price} &#8364;</div>
          </li>
        ) : ( '' )}
      </ul>
    )
  }

  renderDeliveryDetails = () => {
    const {deliveryAddress} = this.props;
    return (
      <ul className="delivery-info__data-list">
        {deliveryAddress.delivery_address.address_string ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Adresse</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.address_string}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.city ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Stadt</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.city}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.zip ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Postleitzahl</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.zip}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.street ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Strasse</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.street}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.house ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Hausnummer</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.house}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.flat ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Wohnung</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.flat}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.floor ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Etage</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.floor}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.elevator_available || !deliveryAddress.delivery_address.elevator_available ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Aufzug</div>
            <div className="delivery-info__data-item-right">{JSON.parse(deliveryAddress.delivery_address.elevator_available) ? "JA" : "NEIN"}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.express_delivery || !deliveryAddress.express_delivery ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Expresslieferung</div>
            <div className="delivery-info__data-item-right">{JSON.parse(deliveryAddress.express_delivery) ? "JA" : "NEIN"}</div>
          </li>
        ) : ( '' )}
      </ul>
    )
  };

  renderCartList = () => {
    const {cart} = this.props;
    const cartElements = cart.map(cartItem => (
      <li key={cartItem.randomId} className="shop-chosen__item">
        <div className="shop-chosen__top">
          <div className="shop-chosen__title">{cartItem.name}</div>
        </div>
        <div className="shop-chosen__bottom">
          <div className="shop-chosen__left">
            <div className="shop-chosen__img">
              <img src={cartItem.icon} alt="" />
            </div>
          </div>
          <div className="shop-chosen__right">
            <ul className="shop-chosen__feature">
              <li className="shop-chosen__feature-item">
                <div className="shop-chosen__feature-left">Anzahl</div>
                <div className="shop-chosen__feature-right">{cartItem.quantity} Stk.</div>
              </li>
              {cartItem.cost ? (
                <li className="shop-chosen__feature-item">
                  <div className="shop-chosen__feature-left">Preis je Artikel</div>
                  <div className="shop-chosen__feature-right">{cartItem.cost} &euro;</div>
                </li>
              ) : ( '' )}
              {cartItem.size ? (
                <li className="shop-chosen__feature-item">
                  <div className="shop-chosen__feature-left">Gesamtlänge</div>
                  <div className="shop-chosen__feature-right">{cartItem.size} m</div>
                </li>
              ) : ( '' )}
              {cartItem.installation ? (
                <li className="shop-chosen__feature-item">
                  <div className="shop-chosen__feature-left">Montage</div>
                  <div className="shop-chosen__feature-right">
                    <img src={iconInstallation} alt="" />
                  </div>
                </li>
              ) : ( '' )}
              {cartItem.bringInWindow ? (
                <li className="shop-chosen__feature-item">
                  <div className="shop-chosen__feature-left">passt nicht durch die Tür / Treppenhaus</div>
                  <div className="shop-chosen__feature-right">
                    <img src={iconInstallation} alt="" />
                  </div>
                </li>
              ) : ( '' )}
            </ul>
          </div>
        </div>
      </li>
    ));
    return (
      <ul className="shop-chosen__list">
        {cartElements}
      </ul>
    )
  };

  render() {
    const {renderCartList, renderDeliveryDetails, renderDeliveryCost} = this;
    const {deliveryData} = this.props;

    return (
      <section className="delivery-info">
        <div className="delivery-info__top">
          <div className="delivery-info__left">
            <h2>Lieferung</h2>
            <div className="delivery-info__data">
              <h3>Daten Ihrer Lieferung</h3>
              { renderDeliveryDetails() }
            </div>
          </div>
          <div className="delivery-info__right">
            <h2>Delivery cost</h2>
            <div className="delivery-info__cost">
              {(!deliveryData.error_message) ? (
                <div>
                  { renderDeliveryCost() }

                  {(deliveryData && deliveryData.trucks_required > 1) ? (
                    <p className="delivery-info__cost-desc">* Aufgrund der Gesamtlänge wird Ihre Ware in Etappen geliefert.</p>
                  ) : ('')}
                </div>
              ) : (
                <p className="delivery-info__cost-desc delivery-info__cost-desc--error">{deliveryData.error_message}</p>
              )}
            </div>
          </div>
        </div>
        <div className="delivery-info__bottom">
          <h2>Artikel</h2>
          <div className="delivery-info__categories">
            { renderCartList() }
          </div>
        </div>
      </section>
    );
  }
}

export default connect((state) => {
  return {
    deliveryData: state.delivery.deliveryData,
    deliveryAddressErrors: state.delivery.deliveryAddressErrors,
    deliveryAddress: state.delivery.deliveryAddress,
    cart: state.cart
  }
}, null)(DeliveryData);


// WEBPACK FOOTER //
// ./src/components/DeliverySteps/DeliveryData.js